export const visitsKeys = {
  all: ['visits'] as const,
  lists: () => [...visitsKeys.all, 'list'] as const,
  list: () => [...visitsKeys.lists()] as const,
  details: () => [...visitsKeys.lists(), 'detail'] as const,
  detail: (id: number) => [...visitsKeys.details(), { id }] as const,
};
